import type { ViewMode } from '@wix/thunderbolt-becky-types'
import type { IPageReflector, PagesSiteConfig } from '../types'
import { name } from '../symbols'
import { ProviderCreator } from '@wix/thunderbolt-ioc'
import {
	CarmiInstance,
	DSViewModeAPISymbol,
	ILogger,
	LoggerSymbol,
	MasterPageFeatureConfigSymbol,
	NavigationInfoSymbol,
	IViewMode,
	PagesModelsRegistrarSymbol,
	IPagesModelsRegistrar,
} from '@wix/thunderbolt-symbols'
import type { DSCarmi } from 'thunderbolt-ds-carmi-root'
import { PageProvider as createPageProvider } from '../PageReflector'

export const PageProvider: ProviderCreator<IPageReflector> = (container) => {
	const pagesModelsRegistrar = container.get<IPagesModelsRegistrar>(PagesModelsRegistrarSymbol)
	const viewModeAPI: IViewMode = container.get(DSViewModeAPISymbol)
	const logger: ILogger = container.get(LoggerSymbol)
	const navigationInfo: any = container.get(NavigationInfoSymbol)
	const { navigation, $runInBatch }: DSCarmi = container.get(CarmiInstance)
	const siteConfig = container.getNamed<PagesSiteConfig>(MasterPageFeatureConfigSymbol, name)
	const pageProvider = createPageProvider(container)

	return async (contextId: string, pageId: string) => {
		const viewMode = viewModeAPI.getWantedViewMode()
		const loadedPageIds = navigationInfo.getLoadedPageIdsByViewMode(viewMode)
		const isPageLoaded = loadedPageIds[pageId]
		let loadPages: Awaited<ReturnType<IPagesModelsRegistrar['fetchPagesModels']>>
		if (!isPageLoaded) {
			loadPages = await pagesModelsRegistrar.fetchPagesModels(
				[pageId],
				viewMode.toUpperCase() as Uppercase<ViewMode>
			)
		}

		try {
			$runInBatch(() => {
				if (!isPageLoaded) {
					loadPages!()
					navigationInfo.updateLoadedPageIds([pageId], viewMode)
				}
				if (pageId !== 'masterPage') {
					const pageType = siteConfig.nonPopupPages[pageId] ? 'primaryPage' : 'lightbox'
					navigation.updatePageId(pageType, pageId)
				}
			})
		} catch (error) {
			logger.captureError(error, {
				tags: { feature: 'pages', method: 'loadPage', dsCarmiError: true },
			})
			throw error
		}

		const pageReflector = pageProvider(contextId, pageId)
		return pageReflector
	}
}
